export default __webpack_public_path__ + "static/media/background-image-2.c56b993c.jpg";